import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "h4"
    }}>{`h4`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{` UXP v2.0`}</p>
    <p>{`A heading element, representing the fourth level in the document hierarchy.`}</p>
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert" />
    <p>{`This element is `}<strong parentName="p">{`not`}</strong>{` theme-aware. If you want theme-aware elements, you should use the Spectrum UXP correlates, or you can style them manually based upon the `}<inlineCode parentName="p">{`prefers-color-scheme`}</inlineCode>{` media query.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en/docs/Web/HTML/Element/h4"
      }}>{`https://developer.mozilla.org/en/docs/Web/HTML/Element/h4`}</a></p>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<h4>Hello, world!</h4>
`}</code></pre>
    <h2 {...{
      "id": "spectrum-uxp-correlate"
    }}>{`Spectrum UXP Correlate`}</h2>
    <p>{`When using Spectrum UXP, you can get a similar rendering using `}<inlineCode parentName="p">{`sp-heading`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-heading size="XS">Hello, World</sp-heading>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      